<section class="event-log">
  <div class="content">
    <app-devices [deviceTitle]="'common.event-log'" [renderedFrom]="name"></app-devices>
  </div>
</section>
